"use strict";let e=null;const u=(t,o)=>{e&&clearTimeout(e),e=setTimeout(()=>{e=null,t()},o)};export default u;
//# sourceMappingURL=debounce.js.map
